import axios from "./config";

/**
 * @function
 * @name getPITReports
 * @description get pit reports
 *
 * */
const getPITReports = (council_id, startDate = null, endDate = null, page = 1, perPage = 15) => {
  const params = {
    'filter[council_id]': council_id,
    page: page,
    per_page: perPage
  };
  
  if (startDate && endDate) {
    params['filter[report_start_date]'] = new Date(startDate).toISOString().split('T')[0];
    params['filter[report_end_date]'] = new Date(endDate).toISOString().split('T')[0];
  }
  
  return axios.get(`/pit-reports`, { params });
};

const getPCTReports = (council_id, startDate = null, endDate = null, page = 1, perPage = 15) => {
  console.log("council_id", council_id);
  const params = {
    'filter[council_id]': council_id,
    page: page,
    per_page: perPage
  };
  
  if (startDate && endDate) {
    params['filter[report_start_date]'] = new Date(startDate).toISOString().split('T')[0];
    params['filter[report_end_date]'] = new Date(endDate).toISOString().split('T')[0];
  }
  
  return axios.get(`/pct-reports`, { params });
};

const getPMCReports = (council_id, startDate = null, endDate = null, page = 1, perPage = 15) => {
  console.log("council_id", council_id);
  const params = {
    'filter[council_id]': council_id,
    page: page,
    per_page: perPage
  };
  
  if (startDate && endDate) {
    params['filter[report_start_date]'] = new Date(startDate).toISOString().split('T')[0];
    params['filter[report_end_date]'] = new Date(endDate).toISOString().split('T')[0];
  }
  
  return axios.get(`/pmc-reports`, { params });
};

/**
 * @function
 * @name downloadPCTReport
 * @description download PCT report file
 * @param {number} reportId - The ID of the PCT report to download
 */
const downloadPCTReport = (reportId) => {
  return axios
    .get(`/pct-reports/${reportId}/download`, {
      responseType: "blob",
    })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      const contentDisposition = response.headers["content-disposition"];
      let filename = `pct_pmc_report_${reportId}.docx`;
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }

      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      return response;
    })
    .catch((error) => {
      console.error("Error downloading PCT report:", error);
      throw error;
    });
};

const reprocessSubmissions = (submissionIds) => {
  const webhookIds = (Array.isArray(submissionIds) ? submissionIds : [submissionIds]).filter(
    (id) => id !== undefined && id !== null && id !== ""
  );

  if (!webhookIds.length) {
    return Promise.reject(new Error("At least one submission ID is required to reprocess submissions."));
  }

  return axios
    .post("/webhooks/reprocess", { webhook_ids: webhookIds })
    .then((response) => response.data);
};

const reportsAPI = {
  getPITReports,
  getPCTReports,
  getPMCReports,
  downloadPCTReport,
  reprocessSubmissions,
};

export default reportsAPI;
